import { render } from "./RequestPasswordReset.vue?vue&type=template&id=30d5b7a4&scoped=true"
import script from "./RequestPasswordReset.vue?vue&type=script&lang=js"
export * from "./RequestPasswordReset.vue?vue&type=script&lang=js"

import "./RequestPasswordReset.vue?vue&type=style&index=0&id=30d5b7a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d5b7a4"]])

export default __exports__